module.exports = __webpack_public_path__ + "05_medium_grey.7edd7fdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/05_medium_grey.png
// module id = KH8j
// module chunks = 0